const THUMBNAIL_SIZES = [
  'high',
  'medium',
  'standard',
  'default',
];

export default function getThumbnail(thumbnails) {
  if (!thumbnails) {
    return;
  }

  const biggestThumbByWidth = _(thumbnails)
    .values()
    .maxBy('width');

  const biggestAvailableSize = _(THUMBNAIL_SIZES)
    .takeWhile(size => _.has(thumbnails, size))
    .head();

  const biggestThumbnail = biggestThumbByWidth || thumbnails[biggestAvailableSize];

  return biggestThumbnail && biggestThumbnail.url.replace(/^https?:/, '');
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parsers/get-thumbnail.js